import * as React from 'react';
import { Dropdown, IDropdownOption } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { generatePeriodsByTemporality, getYearBoundariesForProject } from '../../common/generatePeriods';
import { DateTime } from 'luxon';
import { ITemporality } from '../../system/temporality/TemporalitySystem';
import { FileTemporality } from './DocumentUploadFilesTemporalityDialog';
import Project from '../../system/projects/Project';

export function getFileSize(file: File | Blob): string {
  const bytes = file.size;

  const units = ['bytes', 'KB', 'MB', 'GB', 'TB'];
  let i = 0;
  let size = bytes;

  while (size >= 1024 && i < units.length - 1) {
    size /= 1024;
    i++;
  }

  return `${size.toFixed(2)} ${units[i]}`;
}

interface DocumentDocumentUploadFileListItemProps {
  file: FileTemporality;
  isService: boolean;
  temporalityMonthly: ITemporality | undefined;
  project: Project
  onChange: (changes: Partial<FileTemporality>) => void;
  onBlurField: (field: 'exercise' | 'period') => void;
}

export type DocumentPeriod = { doc_periodo: string; doc_ejercicio: string } | null;

const DocumentUploadFileListItem: React.FC<DocumentDocumentUploadFileListItemProps> = ({ file, isService, temporalityMonthly, project, onChange, onBlurField }) => {
  const { t } = useTranslation();
  
  const [years, setYears] = React.useState<string[]>([])


  React.useEffect(() => {
    const start: DateTime = project.getStart()
    const end: DateTime = project.getEnd()

    if (!start || !end) return

    const startYear = start.year
    const endYear = end.year

    const range: string[] = []
    for (let y = startYear; y <= endYear; y++) {
      range.push(y.toString())
    }

    setYears(range)
  }, [project])

  
  const exercise = file.exercise;
  const selectedTemporality = file.period;
  const error = file.error || {};
  
  const start: DateTime = project.getStart()
  const end: DateTime = project.getEnd()


  const { from, to } = getYearBoundariesForProject(Number(exercise), start, end)
  
  const periods = generatePeriodsByTemporality(from, to, temporalityMonthly)

  const temporalityOptions: IDropdownOption[] = periods.map((temp) => ({
    key: temp.from,
    text: temp.name,
  }));

  return (
    <div>
      <hr />
      <div className="document-control-item-container">
        <div>
          <div>
            <b>{t('Nombre')}:</b> {file.file.name}
          </div>
          <div>
            <b>{t('Peso')}:</b> {getFileSize(file.file)}
          </div>
          {isService && temporalityMonthly && (
            <div>
              <b>{t('Temporalidad')}:</b> {temporalityMonthly.dictemp_nombre}
            </div>
          )}
          <div>
            <b>{t('Tipo')}:</b> {file.file.type}
          </div>
        </div>
        <div className="document-control-item-actions">
          {isService && (
            <div className="document-control-item-inputs">
              <div>
                <label className="opacity-half ms-fontWeight-semibold">{t('Ejercicio')}</label>
                <Dropdown
                  placeholder={t('Selecciona un ejercicio')}
                  options={years.map(y => ({ key: y, text: y }))}
                  onBlur={() => onBlurField('exercise')}
                  selectedKey={exercise}
                  onChange={(_, newValue) => onChange({ exercise: newValue?.text || '', period: '', error: {} })}
                  errorMessage={error.exercise}
                  styles={{ root: { maxWidth: 180, minWidth: 180 } }}
                />
              </div>
              <div>
                <label className="opacity-half ms-fontWeight-semibold">{t('Periodo')}</label>
                <Dropdown
                  placeholder={t('Selecciona un periodo')}
                  options={temporalityOptions}
                  onBlur={() => onBlurField('period')}
                  selectedKey={selectedTemporality}
                  onChange={(_, option) => onChange({ period: String(option?.key), error: {}  })}
                  errorMessage={error.period}
                  styles={{ root: { maxWidth: 180, minWidth: 180 } }}
                  disabled={!exercise}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DocumentUploadFileListItem;
